var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "M13.79 3.41a1.4 1.4 0 0 1 0 1.98L9.18 10l4.61 4.61a1.4 1.4 0 1 1-1.98 1.98l-5.6-5.6a1.4 1.4 0 0 1 0-1.98l5.6-5.6a1.4 1.4 0 0 1 1.98 0",
    clipRule: "evenodd"
  })));
};
export default SvgChevronLeft;